module.exports = __webpack_public_path__ + "static/adjustable-base-2-no-legs-5245ed652ba0fa794cea9bf6adf94741.webp";